import { gql } from "@apollo/client";

export const CREATE_COUPON = gql`
  mutation createCoupon($data: CreateCouponInput!) {
    createCoupon(data: $data) {
      id
      name
      type
      value
      amount
      validity
      franchise_id
      acting_region_id
    }
  }
`;

export const UPDATE_COUPON = gql`
  mutation updateCoupon($data: UpdateCouponInput!) {
    updateCoupon(data: $data) {
      id
      name
      type
      value
      amount
      validity
      franchise_id
      acting_region_id
    }
  }
`;

export default CREATE_COUPON;
